import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { getModule } from "vuex-module-decorators";
import ConfigModule from "@/store/theme/ConfigModule";
import AuthModule from "@/store/auth/AuthModule";
import { authRouter } from "@/router/AuthRouter";
import { adminRouter } from "@/router/AdminRouter";
import { enrollerRouter } from "@/router/EnrollerRouter";
import { getHomeRouteForLoggedInUser } from "@/core/helpers/util";
import { Role } from "@/store/auth/enum/AuthEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/admin/dashboard",
  },
  enrollerRouter,
  authRouter,
  adminRouter,
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to) => {
  // ถ้าผู้ใช้งานกำลังเข้าหน้า login ให้ปล่อยผ่านเลย
  if (to.name === "sign-in") {
    return true;
  }
  // if enroll ให้ปล่อยผ่านเลย
  if (to.name === "enroll-level") {
    return true;
  }

  const configModule = getModule(ConfigModule);
  const authModule = getModule(AuthModule);

  // reset config to initial state
  configModule.resetLayoutConfig();

  // check user authenticated
  const currentUser = await authModule.verifyAuth();

  if (!currentUser) {
    return { name: "sign-in" };
  }

  // ตรวจสอบสิทธิ์การเข้าใช้งานของผู้ใช้
  // จะยอมให้ผู้ใช้งานเข้าได้ก็ต่อเมื่อมีสิทธิ์
  // อย่างน้อย คือสิทธิ์ read ในหน้าจอนั้น ๆ เท่านั้น
  // ไม่อย่างนั้นจะส่งผู้ใช้งานกลับไปยังหน้า login
  if (to.name) {
    const canAccess = await authModule.canAccess(to.name.toString());
    const role = currentUser.role;
    const home = getHomeRouteForLoggedInUser(role);

    if (
      (role === Role.admin || role === Role.all) &&
      !to.name.toString().startsWith(Role.admin)
    ) {
      return home;
    }

    if (!canAccess) {
      return { name: "sign-in" };
    }
  } else {
    return { name: "sign-in" };
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);

  return true;
});

export default router;
